export default __webpack_public_path__ + "static/personalData-5407c52d0adbcf6c503ae2cc2125b696.png";